import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import Isvg from 'react-inlinesvg'
import './Home.scss'

// Icons
import iconMegaphone from '../../sass/icons/icon-megaphone.svg'
import iconBrandLover from '../../sass/icons/icon-brandlover.svg'
import iconTrophy from '../../sass/icons/icon-trophy.svg'
import iconStar from '../../sass/icons/icon-star2.svg'
import iconTarget from '../../sass/icons/icon-target.svg'
import iconConversation from '../../sass/icons/icon-conversation.svg'

const slide01 = {
  dots: true,
  infinite: true,
  arrows: false,
  settings: "unslick",
  responsive: [
    {
      breakpoint: 999999,
      settings: "unslick"
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}


class HomeBox extends Component {

  static contextTypes = {
    t: PropTypes.func.isRequired
  }

  renderSlides (data){
    return data.map(slide => 
      <div className="col-4_xs-12 box">
        <Isvg src={slide.icon} />
        <h3>
          { this.context.t(slide.title, {}, 'Texto do box da home') }
        </h3>
        <p>
          { this.context.t(slide.text, {}, 'Texto do box da home') }
        </p>
      </div>
    )
  }
  
  mountContent () { 
    const imagesArr = [iconMegaphone, iconBrandLover, iconTrophy, iconStar, iconTarget, iconConversation]
    const textContent = this.props.content || []
    return textContent.map((item, index) => {
      return {
        title: item.title,
        text: item.text,
        icon: imagesArr[index]
      }
    })
  }
  render() {
    const { title } = this.props
    
    return (
      <div className="home-box container" style={{ marginTop: '-20px', padding: '30px 0'}}>
        <div className="grid-center">
          <div className="col-4_xs-12">
            <h2>
              { this.context.t(title || '', {}, 'Título do homebox') }
            </h2>
          </div>
        </div>
        <div>
          <Slider {...slide01} className="dots-slick grid-noGutter-equalHeight">
            { this.renderSlides(this.mountContent()) }
          </Slider>
        </div>

      </div>
    );
  }
}

export default HomeBox;



// WEBPACK FOOTER //
// ./src/components/Box/Home.js